/**
 * モーダル機能
 */
// コンポーネントのスタイルはこのクラス配下にスコープされている (components/*.scss)
const MODAL_CONTAINER_CLASS = "p-renew-2609";

const initModal = () => {
  const modals = document.querySelectorAll("dialog[id]");
  if (!modals.length) return;

  let bodyOffsetY = 0;

  // dialog を body 直下のコンテナへ移動しておく。
  // transform / filter などで包含ブロック（position:fixed の基準になる祖先）を作る要素の中に
  // dialog が残っていると、top layer の dialog がビューポート基準で配置されず、
  // showModal() のフォーカス移動でページが意図しない位置までスクロールしてしまうため。
  // 例: .js-fadeInUp は表示後も transform: translateY(0) を持つ (components/_fadein.scss)
  // body 直下に直接置くとスコープ用クラスの外に出てスタイルが当たらないため、
  // transform を持たないコンテナで包む。
  const container = document.createElement("div");
  container.className = MODAL_CONTAINER_CLASS;
  modals.forEach((modal) => {
    container.appendChild(modal);
  });
  document.body.appendChild(container);

  const scrollDisable = () => {
    bodyOffsetY = window.scrollY;
    document.body.style.top = `${-bodyOffsetY}px`;
    document.body.classList.add("is-scrollLock");
  };

  const scrollValidity = () => {
    document.body.classList.remove("is-scrollLock");
    document.body.style.top = "";
    window.scrollTo({ top: bodyOffsetY, left: 0, behavior: "instant" });
  };

  const closeModal = (modal) => {
    modal.close("cancelled");
    scrollValidity();
  };

  modals.forEach((modal) => {
    modal.addEventListener("cancel", () => closeModal(modal));

    // capture: true で、子要素上のリスナー（chamo-chat）より先に実行される
    modal.addEventListener(
      "click",
      (e) => {
        if (e.target === modal || e.target.closest(".js-modal__close")) {
          closeModal(modal);
        }
      },
      true
    );
  });

  document.querySelectorAll("[data-modal-target]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const modalId = btn.getAttribute("aria-controls");
      const modal = modalId && document.getElementById(modalId);
      if (!modal) return;

      scrollDisable();
      modal.showModal();
    });
  });
};

const modal = () => {
  initModal();
};

export { modal };
